export default {
  title: 'Contact us',
  customerServiceTitle: 'Customer service',
  headOfficeTitle: 'Head office',
  technicalSupportTitle: 'Technical support*',
  openingHours: 'Opening hours',
  telephone: 'Telephone',
  fax: 'Fax',
  email: 'Email*',
  emailPrompt: '*Email exchanges are not a secure method for sharing information.',
};
